import { ActionTypes } from '../constants/ActionTypes';
import { AnyAction } from 'redux';
import { IBasicSearchData } from '../models/IBasicSearchData';
import { IAdvancedSearchData } from '../models/IAdvancedSearchData';
import { ISearchSelectedItem } from '../models/ISearchSelectedItem';


export function SetBasicSearchData(data: IBasicSearchData): AnyAction {
    return {
        type: ActionTypes.SET_BASIC_SEARCH_DATA,
        payload: data
    }
}

export function SetAdvancedSearchData(data: IAdvancedSearchData): AnyAction {
    return {
        type: ActionTypes.SET_ADVANCED_SEARCH_DATA,
        payload: data
    }
}

export function SetNewPage(newPage: number): AnyAction {
    return {
        type: ActionTypes.SET_NEW_PAGE,
        payload: newPage
    }
}

export function ResetSearchDaySpan(): AnyAction {
    return {
        type: ActionTypes.RESET_SEARCH_DAY_SPAN,
        payload: undefined
    }
}

export function SetBasicSearchDataAndResetDaySpan(data: IBasicSearchData): AnyAction {
    return {
        type: ActionTypes.SET_BASIC_SEARCH_DATA_AND_RESET_DAY_SPAN,
        payload: data
    }
}

export function SetSearchSelectedItem(data: ISearchSelectedItem): AnyAction {
    return {
        type: ActionTypes.SET_SEARCH_SELECTED_ITEM,
        payload: data
    }
}

export function SetBasicSearchDataAndResetAdvancedCriteria(data: IBasicSearchData): AnyAction {
    return {
        type: ActionTypes.SET_BASIC_SEARCH_DATA_AND_RESET_ADVANCED_CRITERIA,
        payload: data
    }
}


// WEBPACK FOOTER //
// ./src/actions/SearchActions.tsx